// Muscles tracked in the system
export const MUSCLES = [
  { key: "quadriceps", label: "Quadriceps" },
  { key: "hamstring", label: "Hamstrings" },
  { key: "adductors", label: "Adductors" },
  { key: "calf", label: "Calves" },
  { key: "gluteal", label: "Glutes" },
  { key: "iliopsoas", label: "Hip Flexors" },
];

// Position configuration
export const POSITION_CONFIG = {
  GK: { label: "Goalkeepers", order: 1, color: "amber" },
  CB: { label: "Center Backs", order: 2, color: "blue" },
  LB: { label: "Left Backs", order: 3, color: "blue" },
  RB: { label: "Right Backs", order: 4, color: "blue" },
  CDM: { label: "Defensive Midfielders", order: 5, color: "emerald" },
  CM: { label: "Central Midfielders", order: 6, color: "emerald" },
  CAM: { label: "Attacking Midfielders", order: 7, color: "emerald" },
  LM: { label: "Left Midfielders", order: 8, color: "emerald" },
  RM: { label: "Right Midfielders", order: 9, color: "emerald" },
  LW: { label: "Left Wingers", order: 10, color: "rose" },
  RW: { label: "Right Wingers", order: 11, color: "rose" },
  ST: { label: "Strikers", order: 12, color: "rose" },
  CF: { label: "Center Forwards", order: 13, color: "rose" },
  // French position names mapping
  Gardien: { label: "Goalkeepers", order: 1, color: "amber" },
  "Défenseur": { label: "Defenders", order: 2, color: "blue" },
  Milieu: { label: "Midfielders", order: 6, color: "emerald" },
  Attaquant: { label: "Forwards", order: 12, color: "rose" },
  Ailier: { label: "Wingers", order: 10, color: "rose" },
  // English position names mapping
  Goalkeeper: { label: "Goalkeepers", order: 1, color: "amber" },
  Defender: { label: "Defenders", order: 2, color: "blue" },
  Midfielder: { label: "Midfielders", order: 6, color: "emerald" },
  Forward: { label: "Forwards", order: 12, color: "rose" },
  Winger: { label: "Wingers", order: 10, color: "rose" },
};

// Position groups for team analysis
export const POSITION_GROUPS = {
  "Defenders": ["CB", "LB", "RB", "DÉFENSEUR", "DEFENSE", "DEFENDER"],
  "Midfielders": ["CDM","CM","CAM","LM","RM","MILIEU","MIDFIELD","MIDFIELDER"],
  "Forwards": ["ST","CF","LW","RW","ATTAQUANT","AILIER","ATTACK","FORWARD","STRIKER","WINGER"],
  "Lateral": ["LB","RB","LM","RM","AILIER","WINGER","LATERAL"],
};


export const POSITION_GROUP_COLORS = {
  "Defenders": { primary: "#3b82f6", bg: "bg-blue-500" },
  "Midfielders": { primary: "#10b981", bg: "bg-emerald-500" },
  "Forwards": { primary: "#f43f5e", bg: "bg-rose-500" },
  "Lateral": { primary: "#8b5cf6", bg: "bg-purple-500" },
};
